export default __webpack_public_path__ + "static/media/remove-icon.78416ebf.svg";